export const odluka_promj_amort_stope = {
    templateId: 207.3,
    category: 4,
    templateTitle: 'Odluka o promjeni procjene korisnog vijeka upotrebe',
    templateDescription: `<p>Hrvatskim standardima financijskog izvještavanja propisan je računovodstveni postupak za utvrđivanje korisnog vijeka upotrebe za dugotrajnu materijalnu imovinu i s tim povezana pitanja.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>U skladu sa računovodstvenim standardima, toč. 6.46 HSFI-a 6 – Dugotrajna materijalna imovina (također i u skladu s MRS-om 16), subjekt je dužan preispitati barem jednom na kraju svakog izvještajnog razdoblja korisni vijek upotrebe imovine te ako se očekivanja razlikuju od prethodnih procjena, promjene se priznaju kao promjene u računovodstvenim procjenama, a u skladu s HSFI-om 3 – Računovodstvene politike, promjene računovodstvenih procjena i pogreške, odnosno u skladu sa MRS-om 8.</p>
    <p>Godišnje stope otpisa utvrđuju se prema amortizacijskom vijeku za pojedine skupine dugotrajne imovine: stvari i prava čiji je pojedinačni trošak nabave veći od zakonom utvrđenog iznosa od 3.500,00 kuna i kojima je vijek trajanja duži od godine dana.</p>
    <p>Amortizacijski iznos pojedine imovine treba rasporediti sustavno, tijekom njenog korisnog vijeka upotrebe.    </p>
    <p>Promjena korisnog vijeka uporabe dugotrajne imovine (promjena amortizacijskih stopa) smatra se promjenom računovodstvene procjene, a učinci promjene računovodstvene procjene imaju efekt na dobit/gubitak tekućeg izvještajnog razdoblja i budućih izvještajnih razdoblja, što znači da nema potrebe za retroaktivnom primjenom i ispravcima prethodnih razdoblja i prethodno obračunate amortizacije.</p>
    <p>Primjer dokumenta o utvrđivanju korisnog vijeka upotrebe možete vidjeti <a class="local-link" href="/contract?template=207.2">ovdje</a>, zajedno s pripadajućim opisom dokumenta.</p>
   
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>HRVATSKI STANDARD FINANCIJSKOG IZVJEŠTAVANJA: 6. DUGOTRAJNA MATERIJALNA IMOVINA</p>
    ` ,
  
    sides: [
        {
            prefix: 'Na temelju odredbi Zakona o trgovačkim društvima, Zakona o računovodstvu',
            signature: 'Za Poduzetnika',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Zastupa",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija",
                inSignature: true,
              }],
              suffix: " (u daljnjem tekstu: Društvo),",
        }
    ],

    headline: '​donosi sljedeću',
    title: 'ODLUKU O PROMJENI PROCJENE KORISNOG VIJEKA UPOTREBE',
    noArticleNumbers: true,

    articles: [
     
      {
        title: '',
        mandatory: false,
        exampleContent: true,
        statements: [
            {
                type: 'text',
                editable: true,
                mandatory: true,
                content: 'Društvo je vlasnik stroja ____________________________________________ kupljenog temeljem računa br. _________ od __.__.20__. godine. (u daljnjem tekstu: Stroj).',
                value: '',
            }],
            value: '',
    },
    
    {
      title: '',
      mandatory: false,
      exampleContent: true,
      statements: [
          {
              type: 'text',
              editable: true,
              mandatory: true,
              content: 'Uprava Društva donijela je dana __.__.20__. godine odluku o utvrđivanju korisnog vijeka upotrebe Stroja na __ godina odnosno utvrdilo amortizacijsku stopa od ___ %. ',
              value: '',
          }],
          value: '',
  },
  {
    title: '',
    mandatory: false,
    exampleContent: true,
    statements: [
        {
            type: 'text',
            editable: true,
            mandatory: true,
            content: 'U skladu sa Zakonom o računovodstvu i MRS-om 16 / HSFI 6 Uprava je preispitala korisni vijek upotrebe Stroja te je zaključila da je smanjena/povećana iskorištenost kapaciteta Stroja uslijed  _____________________________, stoga se vijek upotrebe povećava/smanjuje na način određen ovom Odlukom.',
            value: '',
        }],
        value: '',
},
  {
    title: '',
    mandatory: false,
    exampleContent: true,
    statements: [
        {
            type: 'text',
            editable: true,
            mandatory: true,
            content: 'Na temelju ove promjene,  stopa amortizacije se smanjuje/povećava s __ % na __ %.',
            value: '',
        }],
        value: '',
},

{
  title: '',
  mandatory: false,
  exampleContent: true,
  statements: [
      {
          type: 'text',
          editable: true,
          mandatory: true,
          content: 'Učinke navedene promjene procjene računovodstvo će provesti u skladu s MRS 8 / HSFI 3, uključivanjem u rashode razdoblja.',
          value: '',
      }],
      value: '',
},

    {
        title: '',
        mandatory: false,
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Odluka se primjenjuje s danom donošenja.',
                value: '',
            }],
            value: '',
    },
    {
        mandatory: true,
        static: true,
        type: 2, // date and place
        statements: [
            {
                type: 'input',
                mandatory: true,
                parts: [
                    {
                        type: 'text',
                        content: 'U'
                    },
                    {
                        type: 'input',
                        value: '',
                        placeholder: "Upišite mjesto.",
                        required: true
                    },
                    {
                        type: 'text',
                        content: ', dana'
                    },
                    {
                        type: 'date',
                        value: new Date(),
                        required: true
                    },
                    {
                        type: 'text',
                        content: 'godine.',
                    }
                ]
            },
        ]
    },
    {
        mandatory: true,
        static: true,
        type: 3,  // signatures
        statements: [],
    },
    {
        static: true,
        mandatory: false,
        type: 4, 
        statements: [
            {
                type: 'text',
                mandatory: true,
                editable: true,
                content: 'Dostaviti:\r\n1) Odjel knjigovodstva \r\n2) Arhiva',
                help: 'Po želji, slobodno dopišite kome želite dostaviti odluku odnosno izmijenite/obrišite predložene unose.'
            }
        ]
    },
  ],
  };
  


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/207.3_odluka_promj_ amort_stope.ts